import React from 'react';
// import ReactDOM from 'react-dom';
import {closeAll} from '../utils/Modal'

const ModalSignin = () => {

  // const renderContent= useCallback(
  //   () => {
      return (
      <section className="modal-sign-in">
        <button className="close-overlay" onClick={() => closeAll()}/>
        <div className="sign-in">
          <button className="back" onClick={() => closeAll()}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.5 1.5L1.5 10.5" stroke="#070E11" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M1.5 1.5L10.5 10.5" stroke="#070E11" strokeWidth="1.35" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <div className="sign-in-heading">
            <h4>Sign In to continue</h4>
            <a href="https://app.cliphire.co/auth/jobseeker/login" className="button button-white">
              <img src="/img/jobs/mail.svg"/>
              Continue with email
            </a>
            <a href="https://app.cliphire.co/auth/jobseeker/login" className="button button-white">
              <img src="/img/jobs/google.svg"/>
              Continue with Google
            </a>
            <p className="sign-in-footer">Don’t have an account?
              <a href="https://app.cliphire.co/auth/jobseeker/register"> Sign Up</a>
            </p>
          </div>
        </div>
      </section>
      )
  //   },
  //   [modalShow, ModalToggle],
  // )

  // return (<>
  //    {ReactDOM.createPortal(renderContent(), document.getElementById('modal'))}
  //   </>
    
  // );
};

export default ModalSignin;
